import React from 'react';
import { Logo, Button } from '../library-components';
import '../ssoLogin/ssoLogin.scss';

class SsoLogin extends React.Component {
  handleClick (e) {
    window.location.href = decodeURI(this.props.authUri);
  }

  render () {
    return (
      <div className='login-main-wrapper'>
        <div className='logo-wrapper'>
          <Logo
            bgColor={false}
          />
          <span className='logo-text'>Accesstype</span>
        </div>
        <div className='wrapper'>
          <div className='content-wrapper'>
            <div className='title'>
              <h2 className='title-text'>{!this.props.currentUserId ? `Sign in` : `Sign out`}</h2>
            </div>
            <div className='content'>
              <p className='description'>{!this.props.currentUserId ? `Sign in to your accesstype account to access your dashboard` : `You may contact your admin to provide access to an Accesstype account or write to us as at support@quintype.com to get access.`}</p>
            </div>
          </div>
          <div className="signin-wrapper">
            <div className='signin-fields'>
              <div className='button-wrapper'>
                {!this.props.currentUserId
                  ? <Button customClass='signin-button' onClick={(e) => this.handleClick(e)}> Sign in </Button>
                  : <Button customClass='signout-button' onClick={(e) => { window.location = '/logout'; }}> Sign out </Button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SsoLogin;
